import {
  CompanyIdentityProvider,
  CreateCompanyIdentityProviderRequest,
  identityProvidersService,
} from '@aslanpay/portal-common-lib';
import { useMutation, useQueryClient } from '@tanstack/react-query';

interface CreateIdentityProviderParams {
  companyId: string;
  request: CreateCompanyIdentityProviderRequest;
}

const useCreateIdentityProvider = () => {
  const queryClient = useQueryClient();

  return useMutation<CompanyIdentityProvider, Error, CreateIdentityProviderParams>({
    mutationFn: async ({ companyId, request }: CreateIdentityProviderParams) => {
      return identityProvidersService.createIdentityProvider(companyId, request);
    },
    onSuccess: (_, { companyId }) => {
      queryClient.invalidateQueries({ queryKey: ['fetchIdentityProviders', companyId] });
    },
  });
};

export default useCreateIdentityProvider;
